function isValidMobile(phone) {
    const mobileRegex = /^1[3-9]\d{9}$/;
    return mobileRegex.test(phone);
}

function isValidLandline(phone) {
    const landlineRegex = /^(\(?0\d{2,3}\)?[-]?)?\d{7,8}$/;
    return landlineRegex.test(phone);
}

function isValidInternationalMobile(phone) {
    const cleanedPhone = phone.replace(/[\s.-]/g, '');
    const internationalMobileRegex = /^\+?[1-9]\d{0,3}\d{6,14}$/;

    if (!internationalMobileRegex.test(cleanedPhone)) {
        return false;
    }

    const digitsOnly = cleanedPhone.replace(/\+/g, '');
    return digitsOnly.length >= 7 && digitsOnly.length <= 15;
}

export {
    isValidMobile,
    isValidLandline,
}


// WEBPACK FOOTER //
// ./src/utils/testPhone.js